import { useInjection } from 'inversify-react';

import { Panel } from '@desygner/ui-common-components';

import { TYPES } from '../../../../../inversify.types';
import { IViewerStoreInjector } from '../../../../../store';
import { StyledButtonSize, StyledVideoControllerWrapper } from '../BottomNav.styles';
import { PauseButton } from './PauseButton';
import { ProgressSlider } from './ProgressSlider';
import { StyledFullFlexGrow, StyledNoneflexGrow } from './VideoControllers.styles';
import { Volume } from './Volume';

export const VideoControllers = () => {
  const useViewerStore = useInjection<IViewerStoreInjector>(TYPES.Store.Viewer);
  const currentPlayingMedia = useViewerStore((state) => state.currentPlayingMedia);

  if (!currentPlayingMedia) return null;

  return (
    <StyledVideoControllerWrapper>
      <StyledButtonSize>
        <Panel widthVariant="fullWidth">
          <StyledNoneflexGrow>
            <Panel.Content>
              <PauseButton />
            </Panel.Content>
          </StyledNoneflexGrow>
          <StyledFullFlexGrow>
            <Panel.Content>
              <ProgressSlider />
            </Panel.Content>
          </StyledFullFlexGrow>
          <StyledNoneflexGrow>
            <Panel.Content>
              <Volume />
            </Panel.Content>
          </StyledNoneflexGrow>
        </Panel>
      </StyledButtonSize>
    </StyledVideoControllerWrapper>
  );
};
